<div [attr.id]="layout.data.anchor || null" class="layout-container" [ngClass]="getContainerClasses()">
  <div class="layout-element layout-row" [style]="getRowStyle()">
    <div *ngFor="let section of sortedSections()" class="layout-row--column" [ngStyle]="getSectionStyle(section)">
      <app-layout-row-column [section]="section"></app-layout-row-column>
    </div>
  </div>
</div>
